module.exports = __webpack_public_path__ + "img/SportCarsMasonry.7af25c0c.jpg";